import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';

import {
  eventTypes,
  directions,
  responsible,
  platform,
  game,
  versions,
  channels,
  classTags,
  techTags,
  typeTags,
} from '../../store/selectors/formCollections';
import useDynamicValidate from '../../effects/useDynamicValidate';
import useDynamicLoader from '../../effects/useDynamicLoader';
import usePrevious from '../../effects/usePrevious';
import { getInfo } from './info';
import useDisplayConfig from './useDisplayConfig';
import GeneralForm from './GeneralForm';
import IncedentForm from './IncedentForm';
import { forms } from '../../constants';

function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; i = +1) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

const EventForm = ({
  children,
  settings,
  validateForm,
  setValue,
  values,
  operation,
  ...props
}) => {
  const displayConfig = useDisplayConfig(values);
  const info = useMemo(() => getInfo(values), [values]);

  useDynamicValidate(validateForm, settings.validate);

  useDynamicLoader(values, operation);

  const prevGame = usePrevious(values.game);

  const compareGames = arraysEqual(prevGame, values.game);

  useEffect(() => {
    if (prevGame && !compareGames) {
      setValue('platform');
    }
  }, [values.game]);

  return (
    <>
      {displayConfig.formType === forms.INCEDENT ? (
        <IncedentForm
          fields={settings.fields}
          displayConfig={displayConfig}
          info={info}
          {...props}
        />
      ) : (
        <GeneralForm
          fields={settings.fields}
          displayConfig={displayConfig}
          info={info}
          {...props}
        />
      )}
      <Row gutter={40}>
        <Col span={6} offset={18}>
          {children}
        </Col>
      </Row>
    </>
  );
};

EventForm.propTypes = {
  settings: PropTypes.shape({
    validate: PropTypes.shape({}),
    fields: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  setValue: PropTypes.func.isRequired,
  validateForm: PropTypes.func.isRequired,
  values: PropTypes.shape({
    game: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
  }).isRequired,
  children: PropTypes.node,
  operation: PropTypes.string.isRequired,
};

EventForm.defaultProps = {
  children: null,
};

const mapStateToProps = state => {
  return {
    directions: directions(state),
    eventTypes: eventTypes(state),
    responsible: responsible(state),
    platform: platform(state),
    game: game(state),
    versions: versions(state),
    channels: channels(state),
    classTags: classTags(state),
    typeTags: typeTags(state),
    techTags: techTags(state),
  };
};

export default connect(mapStateToProps)(EventForm);
